import { baseLVNSupervisory } from '../validations/lvn-supervisory/v1';
const shape = baseLVNSupervisory.shape;
export const evaluationFields = [
    { key: 'arrivesAsScheduled', field: shape.arrivesAsScheduled },
    { key: 'followsPOC', field: shape.followsPOC },
    { key: 'positiveAttitude', field: shape.positiveAttitude },
    { key: 'reportsChanges', field: shape.reportsChanges },
    { key: 'useUniversalPrecautions', field: shape.useUniversalPrecautions },
    { key: 'ptConditionChanges', field: shape.ptConditionChanges },
    { key: 'ptSatified', field: shape.ptSatified },
];
